export const siteConfig = {
  name: 'Dalmos Systems',
  legalName:
    'DALMOS SYSTEMS, obrt za informatičke usluge, vl. Noa Matas, Šibenik, Ulica Sedmog kontinenta 1',
  shortLegalName: 'DALMOS SYSTEMS, vl. Noa Matas',
  address: {
    street: 'Ulica Sedmog kontinenta 1',
    postalCode: '22000',
    city: 'Šibenik',
    countryCode: 'HR',
  },
  register: {
    mbo: '99393786',
    registeredOn: '2026-10-09',
    activityCode: '62.10.9',
  },
  domain: 'dalmossystems.com',
  url: 'https://dalmossystems.com',
  foundingYear: 2025,
  email: 'service@dalmossystems.com',
  salesEmail: 'sales@dalmossystems.com',
  phone: '+385 97 612 2350',
  sparsa: {
    email: 'service@dalmossystems.com',
    abuseEmail: 'abuse@dalmossystems.com',
  },
  responseTimeDays: 2,
  ogImage: '/og-image.png',
  themeColor: '#0A1D33',
} as const

export const seatLine = (country: string): string =>
  `${siteConfig.address.street}, ${siteConfig.address.postalCode} ${siteConfig.address.city}, ${country}`

export const contactEndpoint: string = import.meta.env.VITE_CONTACT_ENDPOINT ?? '/api/contact'

export const mailtoHref = (subject: string, body: string): string =>
  `mailto:${siteConfig.salesEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
